.error-message {
    overflow: auto;
    max-width: 500px;
}
